// Fallback for when the HTTP fetch of the matching file under
// src/assets/data/print-labels-data/sheet/ fails. GENERATED FROM THAT FILE - keep
// the two identical: a drifted copy means a fetch failure quietly prints a
// different label, which is the worst moment to find the difference.
export const DEFAULT_QR_SHEET_STYLES: string = `
/* =============================================================================
   Full-sheet copier label styles — one sheet per physical container, WITH QR
   CODE. Twin of large-label-styles.css; see that file for the QR-less layout.

   LITERAL VALUES ONLY — NO var(), NO DESIGN TOKENS.

   This sheet is inlined verbatim into the print iframe, which loads nothing else:
   src/theme/variables.css is not there, so any custom property from the app's
   token layer resolves to nothing and the sheet prints unstyled. A deliberate
   exception to the token convention governing the rest of this repo — do not
   centralize these values.
   ============================================================================= */

/* ---- CALIBRATION KNOBS ------------------------------------------------------
   PrintService.resizeFont shrinks any .label-line that overflows the page width,
   so these are starting sizes, not hard limits. The QR row takes half the page
   height (Job/PO block above, QR row below), so top margin is kept to a minimum
   to leave the rest of the sheet as much room as possible.
   -------------------------------------------------------------------------- */
.label-line      { font-size: 110px; }
.qty-units-line  { font-size: 65px; }             /* BOX n of N */
.contact-line    { font-size: 45px; }
.sheet-qr        { width: 3in; height: 3in; }     /* printed QR square */
/* ---- end calibration knobs ---------------------------------------------- */

/* Basic styles for label. Top padding is deliberately minimal — see the
   calibration note above — everything below the header block is one flex-grow
   row (.qr-code-line) rather than a fixed number of stacked lines. */
.label {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: calc(100vh - 30px); /* Full page height minus 10px top and 20px bottom */
  margin: 0;
  overflow: hidden;
  padding-top: 10px;
  padding-bottom: 20px;
}

/* Each line should scale independently */
.label-line {
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  padding: 5px;
  font-weight: 800;
  line-height: 0.9;
}

.label-line:empty {
  display: none;
  padding: 0;
}

/* The row holding the contact/caption column and the QR column. Grows to fill
   whatever space the header lines above it don't use. */
.qr-code-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1 1 auto;
  overflow: hidden;
}

/* .left and .right each take half the row, centered as a pair rather than each
   centered independently — so the QR square lines up beside the text column
   instead of drifting to the middle of its own half. */
.left,
.right {
  display: flex;
  flex: 1 1 50%;
  min-width: 0;
  height: 100%;
}

/* Text lines stay left-aligned within their column, unlike every other line on
   the sheet — this column reads like a small label, not a centered banner. */
.left {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 5%;
}

.left .label-line {
  text-align: left;
  white-space: normal;
}

.right {
  align-items: center;
  justify-content: center;
}

/* TWIN of .qr-box in dymo-label-styles.css — same idea (a fixed square that
   flex-centres the spliced SVG and collapses when there is none), duplicated
   because each sheet is injected ALONE into its own print iframe: there is no
   cascade a shared sheet could reach, so sharing is impossible by construction
   rather than merely unwanted.

   Divergences from the twin: 3in vs 0.5in, and no margin — this one is centred
   in its own half of the row rather than sitting beside a text column that
   needs holding off it. The .sheet-qr svg body below is byte-identical to its
   twin. */
.sheet-qr {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  max-width: 100%;
  max-height: 100%;
}

.sheet-qr:empty {
  display: none;
}

/* The spliced <svg> carries a viewBox and no width/height, so it scales to the
   box the calibration block sets. */
.sheet-qr svg {
  width: 100%;
  height: 100%;
  display: block;
}

@media print {
  header, footer, .address-bar {
    display: none;
  }

  @page {
    margin: 0;
    size: landscape;
  }

  body {
    margin: 0;
    padding: 0;
  }
}
`;
